<template>
    <el-container class="home-container">
        <div class="shadow"></div>
        <el-aside :width="menuCollapse ? '64px' : '168px'">
            <div class="logo-con">
                <img class="logo"
                    :src="require(menuCollapse ? '@/assets/img/newerp_icon1.png' : '@/assets/img/newerp_button1.png')"
                    alt="" fit="contain" />
            </div>
            <el-menu
              ref="menuRef"
              background-color="#050a3a"
              text-color="#fff"
              active-text-color="#ffffff"
              unique-opened
              :collapse="menuCollapse"
              :collapse-transition="false"
              :default-active="activeId"
              @open="menuOpen"
              @select="menuSelect">
                <!-- 一级菜单 -->
                <template>
                    <el-menu-item v-for="item in subMenuList" :key="item.linkUrl" :index="item.id"><i
                      :class="iconsObj[item.code] || 'el-icon-menu'"></i><span slot="title">{{
                          item.name
                      }}</span></el-menu-item>
                </template>
            </el-menu>
        </el-aside>
        <el-container>
          <!-- 顶部header -->
            <el-header style="height: 50px;">
                <!-- left btn -->
                <div class="left-flex">
                  <div class="toggle-button" @click="toggleCollapse">
                      <i :class="menuCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
                  </div>
                  <!-- 顶部菜单center menu -->
                  <div class="center-menu">
                      <div class="center-menu-item" :class=" menuItem.id === activeTopMenuId ? 'center-menu-active-item' : ''" v-for="(menuItem,index) in topMenus" :key="index" @click="topMenuClick(menuItem)">
                        {{ menuItem.name }}
                      </div>
                  </div>
                </div>
                <!-- right -->
                <div>
                    <!-- <el-tooltip class="item" effect="dark" content="下载历史" placement="top-start">
                        <div class="downLoadClass" @click="downListClicked">
                            <i class="el-icon-download myicon"></i>
                        </div>
                    </el-tooltip> -->
                    <el-tooltip class="item" effect="dark" content="首页" placement="top-start">
                        <div class="downLoadClass" @click="handleToHome">
                            <i class="el-icon-s-home myicon"></i>
                        </div>
                    </el-tooltip>
                    <!-- <el-tooltip class="item" effect="dark" content="数据分析" placement="top-start">
                        <div class="downLoadClass" @click="handleToData">
                            <i class="el-icon-data-line myicon"></i>
                        </div>
                    </el-tooltip> -->
                    <el-dropdown @command="handleCommand">
                        <span class="username">{{ userJobInfo.name }}
                            <i class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="changeRole">切换身份</el-dropdown-item>
                            <el-dropdown-item command="history">下载历史</el-dropdown-item>
                            <el-dropdown-item command="logOut">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </el-header>
            <el-main>
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive"></router-view>
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive"></router-view>
            </el-main>
        </el-container>
        <!-- 选择用户的Dialog -->
        <el-dialog title="选择身份" :visible.sync="selectUserDialogViaible" width="50%">
            <el-table header-cell-class-name="tableHeaderStyle" :data="roleList" border stripe>
                <el-table-column label="部门" prop="deptName"></el-table-column>
                <el-table-column label="岗位" prop="rname"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="userLogin(scope.row)">登录</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </el-container>
</template>

<script>
import { listByLogin, setIdentity } from '@/http/api'
export default {
  data () {
    return {
      iconsObj: {
        race_management: 'el-icon-folder-checked', // 赛务管理
        operational_data_management: 'el-icon-school', // 运营管理
        product_management_home: 'el-icon-set-up', // 产品发布
        academic_management: 'el-icon-collection', // 学术管理
        system_management: 'el-icon-setting', // 系统管理
        financial_system_management: 'el-icon-bank-card' // 财务系统
        // b_data_management: 'el-icon-user',
        // c_data_management: 'el-icon-document',
        // ziranpindu: 'el-icon-s-claim',
        // pczx: 'el-icon-star-on',
        // myh_index: 'el-icon-user-solid'
      },
      subMenuList: [],
      topMenus: [],
      activeId: '', // 左侧选中的菜单id
      activeTopMenuId: '', // 顶部选中菜单的id
      menuCollapse: false,
      menuOpenIndex: '',
      selectUserDialogViaible: false,
      roleList: []
    }
  },
  created () {
    this.navActivePath = window.sessionStorage.getItem('navActivePath')
    this.subMenuList = this.$store.state.menuList
    this.activeId = this.$store.state.activeMenuId
    this.activeTopMenuId = this.$store.state.activeTopMenuId
    this.topMenus = this.$store.state.topMenus
    // console.log('this.subMenuList', this.subMenuList)
    this.userJobInfo = this.$store.state.userJobInfo
  },
  methods: {
    // 下载历史点击事件
    downListClicked () {
      console.log('sssssssss')
      this.$router.push('/home/downListHistory')
    },
    downListClicked2 () {
      this.$router.push('/welcome')
    },
    toggleCollapse () {
      this.menuCollapse = !this.menuCollapse
    },
    saveNavActivePath (navActivePath) {
      console.log(navActivePath)
      window.sessionStorage.setItem('navActivePath', navActivePath)
      this.navActivePath = navActivePath
    },
    workTable () {
      window.sessionStorage.setItem('isFirstLogin', false)
      if (this.navActivePath === '') {
        this.$refs.menuRef.close(this.menuOpenIndex)
        this.navActivePath = ''
        window.sessionStorage.setItem('navActivePath', '')
      }
      switch (this.roleWildcard) {
        case 'A2':
          this.$router.push('/workTable/a2')
          break
        case 'A1':
          this.$router.push('/workTable/a1')
          break
        case 'B1':
          switch (this.deptWildcard) {
            case 'sspcn':
              this.$router.push('/workTable/b1Sspcn')
              break
            case 'baby':
              this.$router.push('/workTable/b1Baby')
              break
            case 'itso':
              this.$router.push('/workTable/b1Itso')
              break
          }
          break
      }
    },
    menuOpen (value) {
      this.menuOpenIndex = value
      console.log(this.menuOpenIndex)
    },
    menuSelect (id) {
      // console.log(id)
      // 记录当前选中的id
      this.$store.commit('SET_ACTIVE_MENU_ID', id)

      // 记录二级菜单
      const topMenus = this.subMenuList.find(item => item.id === id).childMenu
      if (topMenus) {
        this.topMenus = topMenus
        this.$store.commit('SET_TOP_MENUS', topMenus)

        // 默认选中二级菜单的第一个，记录二级菜单的选中id
        const activeTopMenuId = topMenus[0].id
        this.activeTopMenuId = activeTopMenuId
        this.$store.commit('SET_ACTIVE_TOP_MENU_ID', activeTopMenuId)
      } else {
        this.topMenus = []
        this.$store.commit('SET_TOP_MENUS', [])
        this.activeTopMenuId = ''
        this.$store.commit('SET_ACTIVE_TOP_MENU_ID', '')
      }

      // 记录并跳转到对应路由
      const url = this.subMenuList.find(item => item.id === id).linkUrl
      this.$router.push(url)
    },

    topMenuClick (item) {
      this.activeTopMenuId = item.id
      this.$store.commit('SET_ACTIVE_TOP_MENU_ID', this.activeTopMenuId)
      const url = item.linkUrl
      this.$router.push(url)
    },
    handleToData () {
      this.clearSelect()
      this.$router.push('/individual_racing_tool/signup_statistics')
    },
    handleToHome () {
      this.clearSelect()
      this.$router.push('/welcome')
    },
    clearSelect () {
      this.activeId = ''
      this.$store.commit('SET_ACTIVE_MENU_ID', '')
      this.topMenus = []
      this.$store.commit('SET_TOP_MENUS', [])
      this.activeTopMenuId = ''
      this.$store.commit('SET_ACTIVE_TOP_MENU_ID', '')
    },
    handleCommand (command) {
      switch (command) {
        case 'logOut':
          window.sessionStorage.clear()
          this.$router.push('/login')
          break
        case 'changeRole':
          this.getUserRoleList()
          break
        case 'history':
          this.downListClicked()
          break
      }
    },
    getUserRoleList () {
      listByLogin().then((res) => {
        this.roleList = res.data
        this.selectUserDialogViaible = true
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 选择身份后登录
    userLogin (erpUserData) {
      setIdentity({ id: erpUserData.id }).then((res) => {
        console.log('loginres', res)
        this.$store.commit('SET_JOBINFO', erpUserData)
        this.$store.commit('SET_PERMISSION', res.data.roleMenus)
        this.$store.commit('SET_MENULIST', res.data.directoryMenus)
        this.$store.commit('SET_FLAG', erpUserData.wildcard)
        this.$router.push('/home')
        this.$router.go(0) // 刷新页面
      }).catch((err) => {
        console.log('返回的err', err)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.downLoadClass{
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-container {
    height: 100%;
    position: relative;
    .shadow{
        position: absolute;
        left: 0;
        right: 0;
        top: 50px;
        box-shadow: inset 0 10px 10px -10px rgba(5, 10, 58, .2);
        width: 100%;
        height: 10px;
        z-index: 100;
      }
    .logo-con{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px;
    }
    .logo{
        width: 76%;
    }

    .el-header {
        background-color: #fff;
        // box-shadow: 0 8px 10px -4px #050a3a;;
        // box-shadow: inset 0 -4px 10px -10px #050a3a;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #fff;
        font-size: 20px;
        > div {
            display: flex;
            align-items: center;
            img {
                height: 50px;
            }
            .username {
                font-size: 12px;
                color: #000;
                margin-right: 15px;
            }
            span {
                // padding-left: 15px;
            }
        }

        .toggle-button {
            width: 30px;
            height: 30px;
            border-radius: 10px;
            background-color: #f9d64a;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            cursor: pointer;
            color: #000;

            // background-color: #4a5064;
            // font-size: 10px;
            // line-height: 24px;
            // color: #fff;
            // text-align: center;
            // letter-spacing: 0.2em;
            // cursor: pointer;
        }
    }

    .el-aside {
        background-color: #050a3a;

        .el-menu {
            border-right: none;
        }

        .iconfont {
            margin-right: 10px;
        }
    }

    .el-main {
        background-color: #eaedf1;
        height: calc(100vh - 50px);
    }
}
.myicon{
  color: #000;
  font-size: 20px;
  cursor: pointer;
  margin-top: 2px;
}
/* 使用深度选择器修改菜单项 hover 背景色 */
::v-deep .el-menu-item:hover{
  color: #f9d64a !important;
}
::v-deep .el-menu-item:hover i {
  color: #f9d64a;
}
::v-deep .el-menu-item.is-active {
  background-color: #f9d64a !important;
  color: #000 !important; /* 可选：同时修改文字颜色 */
}
::v-deep .el-menu-item i{
    color: #fff;
}
::v-deep .el-menu-item.is-active i{
    color: #000;
}
.left-flex{
  display: flex;
}
.center-menu {
  display: flex;
  margin-left: 20px;
}
.center-menu-item{
  width: 80px;
  text-align: center;
  font-size: 14px;
  color: #909399;
  margin-left: 40px;
  cursor: pointer;
  &.center-menu-active-item{
    color: #1f30c7;
    font-weight: bold;
    position: relative;
    &::after{
      content: '';
      display: block;
      position: absolute;
      bottom: -12px;
      left: 20px;
      right: 20px;
      height: 2px;
      background-color: #1f30c7;
    }
  }
  &:hover{
    color: #1f30c7;
  }
}
</style>
